import { render, staticRenderFns } from "./KanbanContactList.vue?vue&type=template&id=6579a81a&scoped=true"
import script from "./KanbanContactList.vue?vue&type=script&lang=js"
export * from "./KanbanContactList.vue?vue&type=script&lang=js"
import style0 from "./KanbanContactList.vue?vue&type=style&index=0&id=6579a81a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6579a81a",
  null
  
)

export default component.exports